import { create } from 'zustand'
import { io, Socket } from 'socket.io-client'

interface SocketState {
  socket: Socket | null
  isConnected: boolean
  connect: (token: string) => void
  disconnect: () => void
}

export const useSocketStore = create<SocketState>((set, get) => ({
  socket: null,
  isConnected: false,
  
  connect: (token) => {
    const socket = io('/', {
      auth: { token },
      transports: ['websocket'],
    })
    
    socket.on('connect', () => {
      console.log('Socket connected')
      set({ isConnected: true })
    })
    
    socket.on('disconnect', () => {
      console.log('Socket disconnected')
      set({ isConnected: false })
    })
    
    socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error)
      set({ isConnected: false })
    })
    
    set({ socket })
  },
  
  disconnect: () => {
    const { socket } = get()
    if (socket) {
      socket.disconnect()
      set({ socket: null, isConnected: false })
    }
  },
}))
